export const AccountRoutes = {
	AccountReactivate: '/account/reactivate/:token',
};
